import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import moment from "moment";
export const getSelfSubscriptionCourses = async () => {
  const res = await axios.middleware(
    "https://middleware.cadernovirtual.com.br/aluno.asmx/AutoinscricaoCursos",
    {
      params: {
        alunoid: _cookies.getItem("auth").user?.alunoid,
        data_hora_local: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
        datetime: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
      },
    }
  );
  return res[0].data;
};

export const useSelfSubscriptionCourses = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryFn: getSelfSubscriptionCourses,
    queryKey: ["selfSubscriptionCourses"],
  });
};
